import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BannerModel } from '../shared/models/banner-model';
import { BannerStatusEnum } from '../shared/models/banner-status-enum';
import { BannerTargetEnum } from '../shared/models/banner-target-enum';
import { BannerTypeEnum } from '../shared/models/banner-type-enum';
import { SettingsService } from '../shared/services/settings.service';

@Component({
  selector: 'app-ads-tab-list',
  templateUrl: './ads-tab-list.component.html',
  styleUrls: ['./ads-tab-list.component.less'],
  standalone: false,
})
export class AdsTabListComponent implements OnInit {
  private sub: Subscription;

  @Input() bannerList: BannerModel[];
  @Input() bannerSizes: string;
  @Input() isResponsive: boolean;

  public status: any;
  public type: any;
  public target: any;

  public isActive: boolean;
  public bannerListId: number;

  constructor(
    private settingsService: SettingsService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.status = BannerStatusEnum;
    this.type = BannerTypeEnum;
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((p) => {
      this.bannerListId = +p['id'];
    });
  }

  onBannerStatusChange(bannerId, isChecked) {
    let bannerStatusId =
      isChecked == true ? BannerStatusEnum.Active : BannerStatusEnum.Inactive;

    return this.settingsService
      .updateBannerStatus(bannerId, bannerStatusId)
      .subscribe((c) => {
        console.log();
      });
  }

  onCreateNewBanner() {
    let targetId = this.isResponsive
      ? BannerTargetEnum.Responsive
      : BannerTargetEnum.Desktop;

    this.router.navigate(
      ['/settings/banner-positions', this.bannerListId, 'banners', 'add'],
      {
        queryParams: { device: targetId },
      }
    );
  }
}
